<my-bill-odb-page-base-structure
  [billingDocument]="billingDocument"
  [hasCommonHeader]="hasDataAvailable"
  [hasTopContent]="true"
>
  <ng-container topContent>
    <div
      class="rs-panel-big rs-margin-bottom4-m rs-bg-c2"
      *ngIf="hasDataAvailable && !hasExplanationInfoMessage"
    >
      <h2 class="rs-tit3">{{ section.description }}</h2>
      <p>
        {{ 'bills.cover.usageLevel4.to' | translate }}&nbsp;{{
          selectedItem.description
        }}<br />{{ 'bills.cover.usageLevel4.from' | translate }}&nbsp;{{
          selectedSectionProductSplitIdentifier
        }}
      </p>
    </div>

    <ng-container *ngIf="hasDataAvailable && hasExplanationInfoMessage">
      <div class="rs-flex-row rs-xpandgrid">
        <div class="rs-flex-columns small-12 medium-6">
          <div class="rs-panel-flex">
            <div class="rs-panel-flex-cell-big rs-bg-c2">
              <h2 class="rs-tit3">{{ section.description }}</h2>
              <p>
                {{ 'bills.cover.usageLevel4.to' | translate }}&nbsp;{{
                  selectedItem.description
                }}<br />{{ 'bills.cover.usageLevel4.from' | translate }}&nbsp;{{
                  selectedSectionProductSplitIdentifier
                }}
              </p>
            </div>
          </div>
        </div>
        <div class="rs-flex-columns small-12 medium-6">
          <div class="rs-panel-flex">
            <my-bill-odb-explanation-intro
              billExplanationType="mmsInfoPage"
              [isPlacedAtRightSide]="true"
            ></my-bill-odb-explanation-intro>
          </div>
        </div>
      </div>
      <div class="rs-h-m2"></div>
    </ng-container>

    <lib-spinner *ngIf="isFetching"></lib-spinner>
    <div class="panel rs-no-padding" *ngIf="errorMessageTitle || errorMessage">
      <lib-generic-message-box
        [messageType]="messageBoxTypeError"
        id="messageBoxTypeError"
        [showCross]="false"
        [cypressTag]="messageBoxTypeError"
      >
        <ng-container Title *ngIf="errorMessageTitle">{{
          errorMessageTitle
        }}</ng-container>

        <p Content *ngIf="errorMessage">
          {{ errorMessage }}
        </p>
      </lib-generic-message-box>
    </div>

    <div
      class="panel rs-no-padding"
      *ngIf="messageBoxTitle || messageBoxContent"
    >
      <lib-generic-message-box
        [messageType]="messageBoxTypeInformation"
        id="messageBoxTypeInformation"
        [showCross]="false"
        [cypressTag]="messageBoxTypeInformation"
      >
        <ng-container Title *ngIf="messageBoxTitle">{{
          messageBoxTitle
        }}</ng-container>
        <span
          Content
          [innerHtml]="messageBoxContent"
          *ngIf="messageBoxContent && hasPrivacyOn"
        >
        </span>
        <p Content *ngIf="(messageBoxContent || hasError) && !hasPrivacyOn">
          {{ messageBoxContent }}
        </p>
      </lib-generic-message-box>
    </div>

    <div
      class="rs-table-data clearfix"
      *ngIf="
        !isFetching &&
        !hasError &&
        !isFixedInternetUsage &&
        !isDocumentOlderThan12Months
      "
    >
      <my-bill-odb-usage-level-four-table-header
        [shouldShowDurationColumn]="shouldShowDurationColumn()"
        [hasDurationTypeInSec]="hasDurationTypeInSec()"
        [shouldShowDestinationColumn]="shouldShowDestinationColumn()"
        [billingAccountNumber]="billingAccount?.accountNumber"
        [documentReference]="documentReference"
        (selectedColumns)="handleSelectedColumnsChange($event)"
        (downloadCSVError)="handleDownloadCSVError($event)"
      ></my-bill-odb-usage-level-four-table-header>
      <div class="rs-scroll-h">
        <table
          class="rs-table rs-table-zebra rs-table-has-banner-bottom"
          aria-labelledby="ac-table-title9"
        >
          <thead>
            <tr>
              <ng-container *ngFor="let columnId of selectedColumnIds">
                <th
                  scope="col"
                  attr.aria-sort="{{ timeStampSortingOrder }}"
                  class="rs-nowrap rs-table-sort"
                  *ngIf="columnId === 'datetime'"
                >
                  <a
                    role="button"
                    href="javascript:void(0)"
                    (click)="sortColumn('timeStamp')"
                    class="rs-link-no-decoration rs-table-sort-link"
                    data-tms-button-zone="mybill.detail.usage"
                    data-tms-button-name="sort dateAndTime"
                    [attr.data-tms-context]="documentReference"
                    [attr.data-tms-message-info]="billingAccount?.accountNumber"
                  >
                    {{
                      'bills.cover.usageLevel4.tableHeader.dateAndTime'
                        | translate
                    }}
                    <em
                      class="rs-table-sort-icon"
                      aria-label="Sorted by Name in ascending order"
                    ></em>
                  </a>
                </th>
                <th
                  scope="col"
                  *ngIf="
                    shouldShowDestinationColumn() && columnId === 'destination'
                  "
                  attr.aria-sort="{{ destinationSortingOrder }}"
                  class="rs-nowrap rs-table-sort"
                >
                  <a
                    role="button"
                    href="javascript:void(0)"
                    (click)="sortColumn('destination')"
                    class="rs-link-no-decoration rs-table-sort-link"
                    data-tms-button-zone="mybill.detail.usage"
                    data-tms-button-name="sort destination"
                    [attr.data-tms-context]="documentReference"
                    [attr.data-tms-message-info]="billingAccount?.accountNumber"
                  >
                    {{
                      'bills.cover.usageLevel4.tableHeader.destination'
                        | translate
                    }}
                    <em
                      class="rs-table-sort-icon"
                      aria-label="Sort not in application"
                    ></em>
                  </a>
                </th>
                <th
                  scope="col"
                  attr.aria-sort="{{ durationSortingOrder }}"
                  class="rs-nowrap rs-table-sort"
                  *ngIf="
                    shouldShowDurationColumn() &&
                    columnId === 'durationOrVolume'
                  "
                >
                  <a
                    role="button"
                    href="javascript:void(0)"
                    (click)="sortColumn('duration')"
                    class="rs-link-no-decoration rs-table-sort-link"
                    data-tms-button-zone="mybill.detail.usage"
                    data-tms-button-name="sort duration"
                    [attr.data-tms-context]="documentReference"
                    [attr.data-tms-message-info]="billingAccount?.accountNumber"
                    *ngIf="hasDurationTypeInSec()"
                  >
                    {{
                      'bills.cover.usageLevel4.tableHeader.duration' | translate
                    }}
                    <em
                      class="rs-table-sort-icon"
                      aria-label="Sort not in application"
                    ></em>
                  </a>

                  <a
                    role="button"
                    href="javascript:void(0)"
                    (click)="sortColumn('duration')"
                    class="rs-link-no-decoration rs-table-sort-link"
                    data-tms-button-zone="mybill.detail.usage"
                    data-tms-button-name="sort volume"
                    [attr.data-tms-context]="documentReference"
                    [attr.data-tms-message-info]="billingAccount?.accountNumber"
                    *ngIf="!hasDurationTypeInSec()"
                  >
                    {{
                      'bills.cover.usageLevel4.tableHeader.volume' | translate
                    }}
                    <em
                      class="rs-table-sort-icon"
                      aria-label="Sort not in application"
                    ></em>
                  </a>
                </th>
                <th
                  scope="col"
                  attr.aria-sort="{{ amountSortingOrder }}"
                  class="rs-nowrap rs-table-sort"
                  *ngIf="columnId === 'price'"
                >
                  <a
                    role="button"
                    href="javascript:void(0)"
                    (click)="sortColumn('amount')"
                    data-tms-button-zone="mybill.detail.usage"
                    data-tms-button-name="sort price"
                    [attr.data-tms-context]="documentReference"
                    [attr.data-tms-message-info]="billingAccount?.accountNumber"
                    class="rs-link-no-decoration rs-table-sort-link"
                  >
                    {{
                      'bills.cover.usageLevel4.tableHeader.price' | translate
                    }}
                    <em
                      class="rs-table-sort-icon"
                      aria-label="Sort not in application"
                    ></em>
                  </a>
                </th>
              </ng-container>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let cdrDetail of cdrDetailsDisplayed">
              <ng-container *ngFor="let columnId of selectedColumnIds">
                <td
                  class="rs-nowrap"
                  *ngIf="columnId === 'datetime'"
                  data-cy="odbLevelFourTableData-datetime"
                  [data-cy-value]="cdrDetail.timeStamp"
                >
                  {{ cdrDetail.timeStamp | date : 'dd/MM/YYYY - HH:mm' }}
                </td>
                <ng-container *ngIf="columnId === 'destination'">
                  <td
                    class="rs-nowrap"
                    *ngIf="shouldShowDestinationColumn()"
                    data-cy="odbLevelFourTableData-destination"
                    [data-cy-value]="cdrDetail.destination"
                  >
                    {{ cdrDetail?.destination }}
                  </td>
                </ng-container>
                <td
                  *ngIf="columnId === 'durationOrVolume' && cdrDetail.duration"
                  data-cy="odbLevelFourTableData-durationOrVolume"
                  [data-cy-value]="cdrDetail.duration"
                >
                  {{ cdrDetail.duration | duration }}
                </td>
                <td
                  *ngIf="columnId === 'price'"
                  data-cy="odbLevelFourTableData-price"
                  [data-cy-value]="cdrDetail.amount"
                >
                  <px-currency-amount
                    [amount]="cdrDetail.amount"
                  ></px-currency-amount>
                </td>
              </ng-container>
            </tr>
          </tbody>
        </table>
      </div>
      <my-bill-odb-usage-level-four-table-pagination
        [currentPageNumber]="currentPageNumber"
        [currentPageSize]="currentPageSize"
        [totalNumberOfItems]="cdrDetails?.length"
        (actions)="handleActions($event)"
      >
      </my-bill-odb-usage-level-four-table-pagination>
      <p
        class="rs-font-pxB"
        data-cy="odbUsageLevelFourAmountsExplanation"
        *ngIf="!isFetching && !hasError"
      >
        {{ vatAmountTranslation }}
      </p>
    </div>
  </ng-container>
</my-bill-odb-page-base-structure>
